import Tooltip from "@/tooltip";
import { isValidElement, useState } from "react";
import styles from "./Selectors.module.css";

export function ActionListOption({ option }) {
	const Tag = option.href ? "a" : option.as ? option.as : "div";

	const iconIsComponent = option.icon && typeof option.icon !== "string";

	return (
		<Tag
			className={styles["action-list-option"]}
			onClick={() => option.onClick && option.onClick()}
			tabIndex={0}
			href={option.href}
			target={option.target}
			download={option.download}
		>
			{iconIsComponent ? (
				<option.icon
					className={`${option.className ? option.className : ""}`}
					style={{ height: "1.5rem", width: "1.5rem", verticalAlign: "middle", marginRight: 5 }}
				/>
			) : null}
			{option.icon && !iconIsComponent ? (
				<img
					src={option.icon}
					alt={option.label}
					style={{ height: "1.5rem", width: "1.5rem", verticalAlign: "middle", marginRight: 5 }}
				/>
			) : null}
			{option.label}
		</Tag>
	);
}

export default function ActionList({
	options,
	value,
	children,
	as,
	className,
	direction,
	forceDirection,
	distance,
	...props
}) {
	const [open, setOpen] = useState(false);

	const TagName = as ? as : "div";
	const disabled = props.disabled ? props.disabled : false;

	const optionList = options?.map((Option, index) => {
		if (isValidElement(Option)) return Option;
		return (
			<ActionListOption
				key={index}
				option={Option}
			/>
		);
	});

	return (
		<TagName
			{...{
				className: className ? className : styles["action-list"],
				...props,
			}}
			tabIndex={0}
			onFocus={() => !disabled && setOpen(true)}
			onBlur={() => !disabled && setOpen(false)}
		>
			<Tooltip
				isOpen={open}
				direction={direction ? direction : "down"}
				forceDirection={forceDirection ? forceDirection : false}
				arrow={false}
				tabIndex={0}
				distance={distance ? distance : undefined}
				contentClassName={styles["action-list-options"]}
				content={<>{optionList ? optionList : <div>No Options</div>}</>}
			>
				{children}
			</Tooltip>
		</TagName>
	);
}
